'use client';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledButton = styled(Box)({
  '& .MuiButton-root': {
    minWidth: 64,
    lineHeight: 0,
    fontWeight: 500,
    width: 'inherit',
    overflow: 'hidden',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    verticalAlign: 'middle',
    justifyContent: 'center',
    textOverflow: 'ellipsis',
    textTransform: 'none !important',
  },
});
